import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { MappedName, RefreshMetricsByDim } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { FunctionComponent } from 'react'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { Context } from '~/state'
import { TabConfig } from '~/utils/analytics'
import { PureRefreshBreakdown } from './PureRefreshBreakdown'

type RefreshBreakdownProps = {
  context: Context
  dimensions: Dimension[]
  dimension: Dimension
  currencySymbol: CurrencySymbol
  onTabChange: (dimension: Dimension) => void
  onRowClick: (name: MappedName) => void
  tabsConfig: TabConfig[]
}

export const RefreshBreakdown: FunctionComponent<RefreshBreakdownProps> = ({ context, dimensions, dimension, currencySymbol, onTabChange, onRowClick, tabsConfig }) => {
  const analyticsQuery = useAnalyticsQueryTanstack<RefreshMetricsByDim>('refresh.metrics.by.dim', dimensions, context, { dimension })

  return (
    <PureRefreshBreakdown
      isLoading={analyticsQuery.isFetching}
      error={!!analyticsQuery.error}
      empty={!analyticsQuery.isLoading && !analyticsQuery.data?.name.length}
      onRefreshClick={() => analyticsQuery.refetch()}
      rawData={analyticsQuery.data ?? { name: [] }}
      onTabChange={onTabChange}
      currencySymbol={currencySymbol}
      onRowClick={onRowClick}
      onSortChange={() => {}}
      tabsConfig={tabsConfig}
    />
  )
}
